import { type SectionTileRaisedRightShortnews2Small } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionItemShortnews } from '../Items/BoardSectionItemShortnews';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionTileRaisedRightShortnews2Small['items'];
};

export function BoardSectionTileShortnewsRight2({ boardSectionItems }: Props) {
	const [boardSectionItemLeft, boardSectionItemCenter] = boardSectionItems.left;

	if (boardSectionItemLeft.type === 'empty' || boardSectionItemCenter.type === 'empty') {
		return null;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItem teaser={boardSectionItemLeft} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItem teaser={boardSectionItemCenter} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 2 } }}>
					<BoardSectionItemShortnews shortNews={boardSectionItems.news} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
